var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadadd = function SvgUploadadd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#0095FC",
    rx: 16,
    style: {
      opacity: 0.10000000149011612
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0095FC",
    fillRule: "evenodd",
    d: "M17 8h-2v7H8v2h7v7h2v-7h7v-2h-7z"
  })));
};
export default SvgUploadadd;